import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
// components
// middlewares
import { Navigate } from "react-router-dom";
import Coa5Middleware from "../../../../middleware/modules/accounting/coa5";
import Form from "../../../../components/modules/accounting/coa5/form";
import { Button, Modal } from "react-bootstrap";
import Coa2Middleware from "../../../../middleware/modules/accounting/coa2";
import { Helmet } from "react-helmet";
import i18n from "../../../../i18n";

const mapStateToProps = ({ auth, coa5, coa2 }) => ({
  isAuthenticated: auth.isAuthenticated,
  isProcessing: coa5.isProcessing,
  isError: coa5.isError,
  errorMessage: coa5.errorMessage,
  dataUpdate: coa5.single,
  isSuccess: coa5.isSuccess,
  isReset: coa5.isReset,
  isNewRecord: coa5.isNewRecord,
  onSubmit: coa5.onSubmit,
  coa2List: coa2.helperCoa2,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      closeModal: () => Coa5Middleware.reset(),
      new: (data, search) => Coa5Middleware.beforeSaveNew(data, search),
      update: (id, type, search) =>
        Coa5Middleware.beforeSaveUpdate(id, type, search),
      helperCOA2: (id) => Coa2Middleware.getHelper(id),
    },
    dispatch
  );
};
class FormContainer extends Component {
  static propTypes = {
    isAuthenticated: PropTypes.bool,
    isProcessing: PropTypes.bool,
    isRegistered: PropTypes.bool,
    isError: PropTypes.bool,
    isSuccess: PropTypes.bool,
    dataUpdate: PropTypes.object,
    errorMessage: PropTypes.any,
    onSubmit: PropTypes.bool,
  };

  static defaultProps = {
    isAuthenticated: false,
    isProcessing: false,
    isRegistered: false,
    isSuccess: false,
    isError: false,
    errorMessage: [],
    dataUpdate: null,
    onSubmit: false,
  };
  constructor(props) {
    super(props);
    this.state = {
      modal: {
        title: "",
        show: false,
      },
    };
    this.form = React.createRef();
    this.getData = this.getData.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.close = this.close.bind(this);
  }

  getData() {
    return this.props.showOne(this.props.dataID);
  }

  close() {
    this.props.closeModal();
  }
  submitForm() {
    const { search, isNewRecord, dataUpdate } = this.props;
    var form = this.form.current.runSubmit();
    if (isNewRecord) {
      this.props.new(form, search);
    } else {
      this.props.update(dataUpdate.id, form, search);
    }
  }

  render() {
    const {
      coa2List,
      isNewRecord,
      onSubmit,
      showModal,
      titleModal,
      isReset,
      dataUpdate,
      isProcessing,
      isError,
      errorMessage,
    } = this.props;

    return (
      <>
        <Modal show={showModal} size={"lg"}>
          <Modal.Header>
            <Modal.Title>{titleModal}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Helmet>
              <title>{titleModal}</title>
            </Helmet>
            <Form
              isNewRecord={isNewRecord}
              isReset={isReset}
              data={dataUpdate}
              coa2List={coa2List}
              isProcessing={isProcessing}
              isError={isError}
              errorMessage={errorMessage}
              ref={this.form}
            />
          </Modal.Body>
          <Modal.Footer className={(!onSubmit)?"justify-content-between":"justify-content-center"}>
            {onSubmit ? (
              ""
            ) : (
              <Button variant="secondary" onClick={() => this.close(false)}>
                {i18n.t("Close")}
              </Button>
            )}
            <Button variant="primary" onClick={() => ((onSubmit)?false:this.submitForm(true))}>
              {onSubmit ? (
                <span className="indicator-progress show">
                  {i18n.t("Please wait...")}
                  <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                </span>
              ) : (
                <span className="indicator-label">{i18n.t("Save")}</span>
              )}
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(FormContainer);
